import Vue from 'vue';

const VUE_APP_AUTH_BASE_URL = process.env.VUE_APP_AUTH_BASE_URL;

export const confirmEmailRequest = (payload) => {
  return Vue.axios.put(`${VUE_APP_AUTH_BASE_URL}/authorization/confirm-email`, payload);
};
